/**
 * 模态框
 * 
 * this.props.btnType: 1-病史备注, 2-受试者暂停, 3-事件登记
 * 
 */
import React, { Component } from 'react';
import { Modal } from 'antd';
import { createFromIconfontCN } from '@ant-design/icons';
import './modalOperate.less';
import StopSubject from './stopSubject/stopSubject';
import Disease from './disease/disease';
import EventRegister from './eventRegister/eventRegister';
import { readTargetName } from '../../../../../../utils/storage';


class ModalOperate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stopType: 0, // 默认暂停类型
            modalTitle: '', // 模态框标题
        }
    }

    componentWillMount() {
        let { btnType } = this.props;
        if (btnType == 1) {
            this.setState({
                modalTitle: '病史备注',
            })

        } else if (btnType == 2) {
            this.setState({
                modalTitle: `${readTargetName()}暂停研究`,
            })
        } else if (btnType == 3) {
            this.setState({
                modalTitle: '事件登记',
            })
        }
    }

    /**
     * 关闭模态框
     */
    handleCancel = (v) => {
        this.props.closeModal(v);
    };

    render() {
        let { modalTitle } = this.state;
        let { visible, btnType } = this.props;

        return (
            <>
                <Modal
                    className={'operatorModal'}
                    visible={visible}
                    title={modalTitle}
                    onCancel={this.handleCancel}
                    width={'50%'}
                    centered
                    destroyOnClose
                    footer={null}
                >
                    {btnType == 1 && <Disease />}
                    {btnType == 2 && <StopSubject enableCancel={this.props.enableCancel} subjectCode={this.props.subjectCode} handleCancel={(v) => this.handleCancel(v)} />}
                    {btnType == 3 && <EventRegister />}
                </Modal>
            </>
        );
    }
}

export default ModalOperate;